import { createSelector } from 'reselect';
import {
    get,
    isEqual
} from 'lodash';
import {
    CAPTURE_BULK_FAILURE,
    CAPTURE_BULK_LOAD,
    CAPTURE_BULK_SUCCESS,
    CAPTURE_FAILURE,
    CAPTURE_LOAD,
    CAPTURE_SUCCESS
} from './captureActions';
import { getEntityByName } from '../appEntities';

export default function reducer(state = {}, action = {}) {
    let newState;
    switch (action.type) {
        case CAPTURE_LOAD:
            newState = {
                ...state,
                captures: {
                    ...state.captures,
                    [action.id]: {
                        error: null,
                        loading: true,
                        success: false,
                        amountCaptured: null
                    }
                }
            };

            return isEqual(state, newState) ? state : newState;

        case CAPTURE_SUCCESS:
            newState = {
                ...state,
                captures: {
                    ...state.captures,
                    [action.id]: {
                        error: null,
                        loading: false,
                        success: true,
                        amountCaptured: action.amountCaptured
                    }
                }
            };

            return isEqual(state, newState) ? state : newState;

        case CAPTURE_FAILURE: {
            newState = {
                ...state,
                captures: {
                    ...state.captures,
                    [action.id]: {
                        error: action.error,
                        loading: false,
                        success: false,
                        amountCaptured: null
                    }
                }
            };

            return isEqual(state, newState) ? state : newState;
        }

        case CAPTURE_BULK_LOAD:
            newState = {
                ...state,
                error: null,
                bulkCaptureLoading: true,
                bulkCaptureSuccessful: false
            };

            return isEqual(state, newState) ? state : newState;

        case CAPTURE_BULK_SUCCESS:
            newState = {
                ...state,
                bulkCaptureLoading: false,
                bulkCaptureSuccessful: true
            };

            return isEqual(state, newState) ? state : newState;

        case CAPTURE_BULK_FAILURE:
            newState = {
                ...state,
                error: action.error,
                bulkCaptureLoading: false
            };

            return isEqual(state, newState) ? state : newState;

        default:
            return state;
    }
}

export const getCaptureEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'capture')
);

export const getCaptures = createSelector(
    getCaptureEntity,
    (entity) => get(entity, 'captures')
);

export const getCaptureObjectById = createSelector(
    getCaptures,
    (state, id) => id,
    (captures, id = '') => get(captures, id)
);

export const getIsCaptureLoadingById = createSelector(
    (state, id) => getCaptureObjectById(state, id),
    (transactionCaptureObject) => get(transactionCaptureObject, 'loading')
);

export const getIsCaptureSuccessfulById = createSelector(
    (state, id) => getCaptureObjectById(state, id),
    (transactionCaptureObject) => get(transactionCaptureObject, 'success')
);

export const getAmountCapturedById = createSelector(
    (state, id) => getCaptureObjectById(state, id),
    (transactionCaptureObject) => get(transactionCaptureObject, 'amountCaptured')
);

export const getCaptureErrorById = createSelector(
    (state, id) => getCaptureObjectById(state, id),
    (transactionCaptureObject) => get(transactionCaptureObject, 'error')
);

export const getCaptureErrorMessageById = createSelector(
    (state, id) => getCaptureErrorById(state, id),
    (error) => get(error, 'message')
);

export const getIsBulkCaptureSuccessful = createSelector(
    getCaptureEntity,
    (entity) => get(entity, 'bulkCaptureSuccessful')
);

export const getBulkCaptureError = createSelector(
    getCaptureEntity,
    (entity) => get(entity, 'error')
);

export const getBulkCaptureErrorMessage = createSelector(
    getBulkCaptureError,
    (error) => get(error, 'message')
);

export const getIsBulkCaptureLoading = createSelector(
    getCaptureEntity,
    (entity) => get(entity, 'bulkCaptureLoading')
);
